<template>
  <div class="app-container-v2 table-container-v2">
    <div class="title-box">
      <div class="title-left">
        <div class="input-v2">
          <el-date-picker
            class="query-select"
            v-model="queryParams.wageYear"
            type="year"
            format="yyyy"
            value-format="yyyy"
            placeholder="年份"
            @change="handleSearch"
          />
        </div>
        <div class="select-v2">
          <el-select
            class="query-select"
            v-model="queryParams.dataType"
            placeholder="数据类型"
            filterable
            clearable
            @change="handleSearch"
          >
            <el-option
              v-for="item in dataTypeList"
              :key="item.codeItemId"
              :value="item.codeItemId"
              :label="item.codeItemName"
            />
          </el-select>
        </div>
        <div class="select-v2">
          <el-select
            class="query-select"
            v-model="queryParams.incomeRange"
            placeholder="收入范围"
            filterable
            clearable
            @change="handleSearch"
          >
            <el-option
              v-for="item in rangeList"
              :key="item.codeItemId"
              :value="item.codeItemName"
              :label="item.codeItemName"
            />
          </el-select>
        </div>
      </div>
      <div class="title-right">
        <el-button type="primary" class="button-v2" @click="handleImport">导入</el-button>
        <el-button type="primary" class="button-v2" @click="handleAdd">新增</el-button>
      </div>
    </div>
    
    <div class="table-body flex vertical" v-loading="loading">
      <air-table
        ref="airTable"
        class="table-v2"
        :show-checkbox="false"
        align="center"
        :columns="columns"
        :data="tableData"
      >
        <template #operation="{ row }">
          <div class="flex center mt4">
            <span class="text-button" @click="handleEdit(row)">编辑</span>
            <div class="divider ml10 mr10"></div>
            <span class="text-button" @click="handleDelete(row)">删除</span>
          </div>
        </template>
      </air-table>
      
      <vxe-pager
        class="pager-v2"
        background
        :current-page.sync="queryParams.page"
        :page-size.sync="queryParams.limit"
        :total="total"
        :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'Sizes', 'Total']"
        @page-change="getData"
      ></vxe-pager>
    </div>
    
    <el-dialog class="modal-v2" :title="employeeModal.title" :visible.sync="employeeModal.show" :close-on-click-modal="false" width="600px" append-to-body>
      <div class="flex vertical">
        <el-form ref="form" class="form-v2" :model="form" :rules="formRules" label-width="90px" style="padding: 30px;">
          <el-form-item label="排序" prop="orderSeq">
            <el-input v-model.number="form.orderSeq" class="input-v2" placeholder="排序"></el-input>
          </el-form-item>
          <el-form-item label="年份" prop="wageYear">
            <el-date-picker v-model="form.wageYear" class="input-v2" type="year" placeholder="请选择年份" format="yyyy" value-format="yyyy"></el-date-picker>
          </el-form-item>
          <el-form-item label="数据类型" prop="dataType">
            <el-select v-model="form.dataType" class="select-v2" placeholder="请选择数据类型">
              <el-option v-for="item in dataTypeList" :key="item.codeItemId" :label="item.codeItemName" :value="item.codeItemId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="收入范围" prop="incomeRange" filterable>
            <el-select v-model="form.incomeRange" class="select-v2" placeholder="请选择数据类型">
              <el-option v-for="item in rangeList" :key="item.codeItemId" :label="item.codeItemName" :value="item.codeItemName"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="范围人数" prop="rangeNum">
            <el-input v-model.number="form.rangeNum" class="input-v2" placeholder="请输入人数"></el-input>
          </el-form-item>
          <el-form-item label="人员明细" prop="rangeDetail">
            <el-input v-model="form.rangeDetail" class="textarea-v2" type="textarea" placeholder="请输入人员明细，以英文逗号分隔"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="w100 flex jbetween acenter">
        <el-button plain class="button-v2" @click="employeeModal.show = false">取消</el-button>
        <el-button type="primary" class="button-v2" :loading="submitLoading" @click="handleSave">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog class="air-modal upload-modal" :title="uploadModal.title" :visible.sync="uploadModal.show" :close-on-click-modal="false" width="420px" append-to-body @close="cancelUpload" v-dialog-drag>
      <div class="upload-container flex vertical">
        <el-upload
          ref="upload"
          drag
          :limit="1"
          accept=".xlsx, .xls"
          :headers="uploadModal.headers"
          :data="uploadModal.data"
          :action="uploadModal.url"
          :disabled="uploadModal.isUploading"
          :on-progress="handleFileUploadProgress"
          :on-success="handleFileSuccess"
          :auto-upload="false"
        >
          <div class="upload-body flex vertical acenter">
            <img src="@/air/assets/img/icon/excel.png" />
            <el-button plain>上传文件</el-button>
            <span class="upload-tips">将文件拖到此处或点击上传，仅支持xls或xlsx文件。</span>
          </div>
        </el-upload>
      </div>
      <div slot="footer" class="air-modal-footer flex jbetween acenter">
        <el-button plain @click="downloadTemplate">下载模板</el-button>
        <div>
          <el-button type="text" class="text-button-cancel" @click="cancelUpload">取消</el-button>
          <el-button :loading="submitLoading" type="primary" @click="submitFileForm">确定</el-button>
        </div>
      </div>
    </el-dialog>
    
    <air-confirm-v2
      :show.sync="confirmShow"
      :title="confirmTitle"
      :content="confirmContent"
      :confirm-function="confirmFunction"
    ></air-confirm-v2>
  </div>
</template>

<script>
  import { validatenull } from '@/util/validate';
  import * as api from '@/api/data-input/data-input'
  import store from '../../store'
  export default {
    name: 'EmployeeCompensation',
    data() {
      return {
        loading: true,
        dataTypeList: [
          { codeItemName: '预测实际', codeItemId: 'reckon' },
          { codeItemName: '预测归属', codeItemId: 'reckonBelong' },
          { codeItemName: '实际', codeItemId: 'real' },
          { codeItemName: '归属', codeItemId: 'realBelong' }
        ],
        rangeList: [
          { codeItemName: '0-20W', codeItemId: 1 },
          { codeItemName: '20-40W', codeItemId: 2 },
          { codeItemName: '40-60W', codeItemId: 3 },
          { codeItemName: '60-80W', codeItemId: 4 },
          { codeItemName: '80-100W', codeItemId: 5 },
          { codeItemName: '100-200W', codeItemId: 6 },
          { codeItemName: '200-300W', codeItemId: 7 },
          { codeItemName: '300W+', codeItemId: 8 }
        ],
        queryParams: {
          wageYear: '',
          dataType: '',
          incomeRange: '',
          page: 1,
          limit: 20
        },
        total: 0,
        columns: [
          {title: '年份', field: 'wageYear', minWidth: 120, fixed: 'left'},
          {title: '数据类型', field: 'dataTypeText', minWidth: 120},
          {title: '收入范围', field: 'incomeRange', minWidth: 120},
          {title: '人员明细', field: 'rangeDetail', minWidth: 200},
          {title: '范围人数', field: 'rangeNum', minWidth: 120},
          {title: '排序', field: 'orderSeq', minWidth: 120}
        ],
        tableData: [],
        form: {},
        formRules: {
          wageYear: [{ required: true, message: '请选择年份', trigger: 'change' }],
          dataType: [{ required: true, message: '请选择类型', trigger: 'change' }],
          incomeRange: [{ required: true, message: '请选择收入范围', trigger: 'change' }],
          rangeDetail: [{ required: true, message: '请输入人员明细', trigger: 'blur' }],
          rangeNum: [{ required: true, message: '请输入人数', trigger: 'blur' }, { type: 'number', message: '请输入正确的人数'}],
          orderSeq: [{ required: true, message: '请输入排序序号', trigger: 'blur' }, { type: 'number', message: '请输入正整数'}]
        },
        dictMap: {},
        employeeModal: {
          show: false,
          title: '添加信息',
          edit: false
        },
        uploadModal: {
          headers: { Authorization: `Bearer ${store.getters.accessToken}` },
          show: false,
          title: '导入数据',
          isUploading: false,
          data: {},
          url: '/api/sys/cofcodata/uploadESLDTemplate/'
        },
        submitLoading: false,
        confirmShow: false,
        confirmTitle: '',
        confirmContent: '',
        confirmFunction: undefined
      }
    },
    created() {
      this.init()
    },
    methods: {
      init() {
        this.getData()
      },
      handleSearch() {
        this.queryParams.page = 1
        this.getData()
      },
      getData() {
        this.loading = true
        api.getESLD(this.queryParams).then(res => {
          if (!this.dictMap.dataType) {
            this.dictMap.dataType = this.$arrayToObj(this.dataTypeList, 'codeItemId')
          }
          this.tableData = this.$handleTableDict(res.data.data.records, this.dictMap)
          this.total = res.data.data.total
          this.loading = false
        }).catch(() => this.loading = false)
      },
      reset() {
        this.form = {}
        this.submitLoading = false
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      },
      handleAdd() {
        this.reset()
        this.employeeModal.title = '添加信息'
        this.employeeModal.edit = false
        this.employeeModal.show = true
      },
      handleEdit(item) {
        this.form = {
          ...item,
          rangeNum: Number(item.rangeNum),
          orderSeq: Number(item.orderSeq)
        }
        this.employeeModal.title = '编辑信息'
        this.employeeModal.edit = true
        this.employeeModal.show = true
      },
      handleSave() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true
            let apiFn = this.employeeModal.edit ? api.updateESLD : api.addESLD
            apiFn(this.form).then(res => {
              if (res.data.code === 0) {
                this.$msgSuccess('保存成功')
                if (this.employeeModal.edit) {
                  this.handleSearch()
                }
                this.employeeModal.show = false
              }
            }).finally(() => this.submitLoading = false)
          }
        })
      },
      handleDelete(item) {
        this.confirmShow = true
        this.confirmTitle = '删除'
        this.confirmContent = `确认删除「${ item.wageYear }年${ item.dataTypeText }」数据?`
        this.confirmFunction = () => {
          const params = {
            ids: [item.id]
          }
          api.deleteESLD(params).then(() => {
            this.getData()
            this.$msgSuccess('删除成功')
          })
        }
      },
      handleImport() {
        this.uploadModal.show = true;
        this.uploadModal.isUploading = false
        this.submitLoading = false
      },
      cancelUpload() {
        this.$refs.upload.clearFiles()
        this.uploadModal.show = false
      },
      downloadTemplate() {
        api.getESLDTemplate({}).then(res => {
          this.$downloadFile(res)
        })
      },
      // 文件上传中处理
      handleFileUploadProgress(event, file, fileList) {
        this.uploadModal.isUploading = true
      },
      // 文件上传成功处理
      handleFileSuccess(response, file, fileList) {
        this.$refs.upload.clearFiles()
        if (response.code == 0) {
          this.uploadModal.show = false
          this.getData()
        } else {
          this.$msgError(response.msg);
          this.uploadModal.isUploading = false;
          this.submitLoading = false;
        }
      },
      // 提交上传文件
      submitFileForm() {
        if (!this.$refs.upload.uploadFiles.length) {
          this.$msgError('您未选择任何文件')
          return
        }
        this.submitLoading = true
        this.$refs.upload.submit()
        this.uploadModal.show = false;
        this.getData()
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "~@/air/assets/css/main.scss";
</style>
